<template>
    <div v-if="!loading" class="create">
        <b-container class="main_layer py-3" fluid>
            <b-container>
                <b-row>
                    <b-col>
                        <p class="fs-36 fw-600 white-color my-2 if-tablet">
                            Внесистемная закупка <template v-if="purchase.reg_number">№ {{ purchase.reg_number }}</template>
                        </p>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <p class="fs-14 greyBg-color mb-1">&laquo;{{ $store.state.organization.short_name }}&raquo;</p>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <p class="fs-14 greyBg-color">
                            Пользователь:
                            {{ $store.state.user.full_name }}
                        </p>
                    </b-col>
                </b-row>
            </b-container>
        </b-container>
        <b-container fluid style="background-color: #f5f5f7">
            <b-container class="my-3">
                <online-course-regular-button class="mb-3" />

                <text-header> Информация о закупке</text-header>

                <form-row-edit-textarea v-model="purchase.comment" :rows="5" label="Примечание к закупке (отображается только в ЛК Заказчика)" />
                <form-row-single-select v-model="purchase.order_type_id" :disabled="!!purchase.failed_fl44_purchase_id" :options="dictionaries.orderTypes" :v="$v.purchase.order_type_id" label="Тип закупки" label-field="title" placeholder="Выберите тип закупки" @input="orderTypeChanged(true)" />
                <form-row-single-select
                    v-if="!isBasedOnFailedPurchase && !customerCanCreateHiddenPurchase"
                    v-model="purchase.fl44_external_purchase_category_id"
                    :options.sync="activeExternalPurchaseCategories"
                    :v="$v.purchase.fl44_external_purchase_category_id"
                    label="Категория закупки"
                    label-field="name"
                    placeholder="Выберите категорию закупки"
                    @input="handleExternalPurchaseCategoryChange" />
                <text-row v-if="isBasedOnFailedPurchase" label="Номер несостоявшейся закупки" :value="failedPurchaseData?.breadcrumb" />
                <form-row-edit-text
                    v-if="purchase.failed_fl44_purchase_id && (!purchase.deliverable_group_id || (purchase.deliverable_group_id && $v.purchase.deliverable_group_id.$anyDirty)) && purchase.tru_name"
                    v-model="purchase.tru_name"
                    :v="$v.purchase.tru_name"
                    description='В связи с изменениями в формах создания/редактирования извещений и внесистемных закупок, данное поле более не будет использоваться, пожалуйста, выберите подходящий "Предмет закупки" в поле ниже'
                    disabled
                    label="Наименование закупки" />

                <form-row-edit-checkbox v-if="features.kbk_limits && currentOrderType?.is_limits_used" v-model="iskbklimitoptional" label="Закупка при отсутствии ЛБО (лимитов по КБК)" />
                <form-row-edit-checkbox v-if="features.kbk_limits && !iskbklimitoptional" v-model="purchase.is_advance_report" label="Авансовый отчет" />
                <form-row-single-select v-if="currentOrderType?.is_limits_used && !iskbklimitoptional" v-model="purchase.purchase_limit_year" :options="limitYears" label="Год ПГ (Плана-графика)" label-field="id" placeholder="Выберите год ПГ (Плана-графика)" @input="purchase.limits.items = []" />

                <form-row-single-select
                    v-model="purchase.deliverable_group_id"
                    :disabled="(!!purchase.failed_fl44_purchase_id && purchase.deliverable_group_id && !$v.purchase.deliverable_group_id.$anyDirty) || !purchase.fl44_external_purchase_category_id"
                    :options="purchase.failed_fl44_purchase_id ? dictionaries.purchaseCategories : activePurchaseCategories"
                    :v="$v.purchase.deliverable_group_id"
                    label="Предмет закупки"
                    placeholder="Выберите предмет закупки" />
                <form-row-edit-text
                    v-model="purchase.purchase_object"
                    :disabled="!!purchase.failed_fl44_purchase_id && purchase.purchase_object && !$v.purchase.purchase_object.$anyDirty"
                    :v="$v.purchase.purchase_object"
                    hint="Укажите непосредственно товары, работы, услуги, поставка, выполнение, оказание которых будут являться предметом контракта."
                    label="Объект закупки"
                    placeholder="Введите объект закупки" />
                <form-row-edit-checkbox v-model="purchase.without_vat" :v="$v.purchase.without_vat" label="Поставщик освобождён от уплаты НДС" compact />

                <form-row-specification-table-new
                    id="specification"
                    class="atmo-hash-jump-point"
                    v-model="purchase.deliverables"
                    :spec-error-message="specErrorMessage"
                    :spec-errors="specErrors"
                    :spec-sum="specSum"
                    :v="$v.purchase.deliverables"
                    :with-count-edit="!isBasedOnFailedPurchase"
                    :no-add-spec="isBasedOnFailedPurchase"
                    :no-delete-spec="isBasedOnFailedPurchase"
                    with-vat-edit
                    :without-vat="purchase.without_vat"
                    with-price />

                <limits-editable-table v-if="features.kbk_limits && !iskbklimitoptional" v-model="purchase.limits.items" :total-cost="specSum" @validate="limitsValidate" :limit-year="purchase.purchase_limit_year" :order-type="currentOrderType" purchase-type="fl44_external" :purchase-id="purchaseId">
                    <template v-slot:info>
                        <p>
                            <b-icon-exclamation-triangle-fill class="text-warning" />&nbsp;Внимание! Перед добавлением лимитов проверьте правильность значений полей "Год ПГ" и "Тип закупки" в разделе "Информация о закупке". При изменении любого из этих полей все добавленные в таблицу лимиты по КБК
                            будут удалены.
                        </p>
                    </template>
                </limits-editable-table>

                <text-header>Поставщик</text-header>
                <b-row class="py-3">
                    <b-col md="3">
                        <span class="fs-14 grey-color fw-700">Тип поставщика <span class="red-star">*</span></span>
                    </b-col>
                    <b-col class="fs-14 grey-color" md="9">
                        <b-form-radio-group v-model="purchase.is_private_provider" :disabled="!(!currentExternalPurchaseCategorySupplierLimited || customerCanCreateHiddenPurchase)" :options="providerTypeOptions" stacked />
                    </b-col>
                </b-row>
                <div v-if="!purchase.is_private_provider">
                    <b-row class="py-1">
                        <b-col :state="!!selectedProvider" md="3">
                            <span class="fs-14 grey-color fw-700">Введите ИНН поставщика <span class="red-star">*</span></span>
                        </b-col>
                        <b-col class="fs-14 grey-color" md="9">
                            <b-form-input v-model="providerInn" :state="!!selectedProvider" trim class="fs-14"></b-form-input>
                            <b-form-invalid-feedback v-if="!selectedProvider" class="fs-14">Поставщик не выбран</b-form-invalid-feedback>
                        </b-col>
                    </b-row>
                    <b-row v-if="foundOrganizationBranches || providerKpp" class="py-1">
                        <b-col :state="!!selectedProvider" md="3">
                            <span class="fs-14 grey-color fw-700">Введите КПП поставщика <span class="red-star">*</span></span>
                        </b-col>
                        <b-col class="fs-14 grey-color" md="9">
                            <b-form-input v-model="providerKpp" :state="!!selectedProvider" trim class="fs-14"></b-form-input>
                            <b-form-invalid-feedback v-if="!selectedProvider" class="fs-14">Поставщик не выбран</b-form-invalid-feedback>
                        </b-col>
                    </b-row>
                    <b-row class="py-1 text-right">
                        <b-col class="fs-14 grey-color" md="12">
                            <b-button class="text-uppercase" variant="custom-green" @click="findProvider">Найти</b-button>
                        </b-col>
                    </b-row>
                    <b-row v-if="tmpProvider" class="py-3">
                        <b-col md="3"></b-col>
                        <b-col class="fs-14 grey-color" md="9">
                            <b-row class="py-2">
                                <b-col v-if="tmpProvider.id && !tmpProvider.from_dadata" class="fs-14 grey-color fw-700" md="12">Поставщик зарегистрирован в ИС</b-col>
                            </b-row>
                            <text-row compact label="ИНН" :value="tmpProvider.inn" />
                            <text-row compact label="КПП" :value="tmpProvider.kpp" />
                            <text-row compact label="ОГРН / ОГРНИП" :value="tmpProvider.ogrn" />
                            <text-row compact label="Наименование" :value="tmpProvider.full_name" />
                            <text-row compact label="Фактический адрес" :value="tmpProvider.fact_address" />
                            <div v-if="isForbiddenSupplier" class="text-danger pt-1">Выбор данного поставщика невозможен, так как его предложение было отклонено или он сам отказался заключать контракт</div>
                            <b-button v-if="!selectedProvider" :disabled="isForbiddenSupplier" class="mt-4" variant="custom-green" @click="selectProvider">Подтвердить</b-button>
                            <b-button v-if="!!selectedProvider" class="mt-4" disabled variant="custom-green">Поставщик выбран</b-button>
                        </b-col>
                    </b-row>
                    <b-row v-if="selectedProvider && selectedProvider.from_dadata" class="py-3">
                        <b-col :state="newProviderEmailState" md="3">
                            <span class="fs-14 grey-color fw-700">Введите email для отправки приглашения поставщику <span class="red-star">*</span></span>
                        </b-col>
                        <b-col class="fs-14 grey-color" md="9">
                            <b-form-input v-model="purchase.new_provider.email" :state="newProviderEmailState" trim></b-form-input>
                            <b-form-invalid-feedback v-if="!newProviderEmailState">Введите email</b-form-invalid-feedback>
                        </b-col>
                    </b-row>
                </div>
                <div v-else>
                    <form-row-edit-text label="ИНН" v-model.trim="purchase.private_provider_data.inn" :v="$v.purchase.private_provider_data.inn" />
                    <form-row-edit-text label="ФИО" v-model.trim="purchase.private_provider_data.name" :v="$v.purchase.private_provider_data.name" />
                    <form-row-edit-address-wo-coordinates v-model="purchase.private_provider_data.address" :v="$v.purchase.private_provider_data.address" label="Адрес регистрации" />
                </div>

                <text-header>Информация о заключенном контракте</text-header>
                <form-row-edit-date v-model="purchase.contract_conclusion_date" :max-date="$now()" :v="$v.purchase.contract_conclusion_date" label="Дата заключения контракта" />
                <text-row label="Статус контракта" :value="statusTitle" hint="Изменение статуса доступно после сохранения закупки." />
                <form-row-edit-date
                    v-if="purchase.status === 'contract:fulfilled'"
                    v-model="purchase.contract_execution_date"
                    :disabled="!purchase.contract_conclusion_date"
                    :max-date="$now()"
                    :min-date="purchase.contract_conclusion_date"
                    :v="$v.purchase.contract_execution_date"
                    label="Дата исполнения контракта" />
                <form-row-single-line-document-upload v-model="purchase.contract_attachment" :label-cols-lg="3" :v="$v.purchase.contract_attachment" title="Контракт" />
                <form-row-edit-text v-model="purchase.customer_contract_number" :description="iskbklimitoptional ? null : Config.get('theme.variables.view.customer_contract_number_description')" :v="$v.purchase.customer_contract_number" label="Номер контракта в системе учета заказчика" />

                <form-row-edit-supplier-accounting v-if="features.kbk_limits && !iskbklimitoptional && !purchase.is_advance_report" v-model="purchase.supplier_accounting" @validate="supplierAccountingValidate">
                    <template #info>
                        <span>Укажите банковские реквизиты поставщика для передачи в РИС.</span>
                    </template>
                </form-row-edit-supplier-accounting>

                <form-row-upload-multiple-documents v-model="purchase.execution_documents" :v="$v.purchase.execution_documents" class="my-3" title="Документы об исполнении" />
                <p v-if="specErrors" class="text-danger fs-14" v-text="specErrorMessage"></p>
                <p v-if="limitError" class="text-danger fs-14" v-text="limitErrorMessage"></p>

                <b-row class="my-3 mt-5">
                    <b-col>
                        <b-overlay :show="isDataSending" class="d-inline-block" opacity="0.6" rounded spinner-small spinner-variant="primary">
                            <b-button class="mr-2 text-uppercase" variant="custom-outline-secondary" @click="onCancel">Отменить</b-button>
                        </b-overlay>
                        <b-overlay :show="isDataSending" class="d-inline-block" opacity="0.6" rounded spinner-small spinner-variant="primary">
                            <b-button class="mr-2 text-uppercase" variant="custom-danger" @click="sendData(true)">Сохранить черновик</b-button>
                        </b-overlay>
                        <b-overlay :show="isDataSending" class="d-inline-block" opacity="0.6" rounded spinner-small spinner-variant="primary">
                            <b-button :disabled="!isValid" class="text-uppercase" variant="custom-green" @click="sendData(false)">Сохранить и опубликовать</b-button>
                        </b-overlay>
                    </b-col>
                </b-row>
            </b-container>
        </b-container>
    </div>
</template>

<script>
import { maxLength, minLength, minValue, required, requiredIf } from 'vuelidate/lib/validators';
import { mapGetters } from 'vuex';

// Rearchitected.
import range from 'lodash.range';
import Config from '@/rearchitected/core/js/ddriven/application/config/Config';
import roundToTwoDecimals from '@/rearchitected/lib/js/src/misc/roundToTwoDecimals';
import FormRowUploadMultipleDocuments from '@/components/common/form-rows/form-row-upload-multiple-documents.vue';
import OnlineCourseRegularButton from '@/components/elements/OnlineCourseRegularButton.vue';

export default {
    name: 'ExternalPurchaseCreate',
    metaInfo: {
        title: 'Создание закупки вне ИС'
    },
    components: {
        OnlineCourseRegularButton,
        FormRowUploadMultipleDocuments
    },
    created() {
        !this.features.kbk_limits && (this.$data.iskbklimitoptional = true);
    },
    data() {
        return {
            isDataSending: false,
            iskbklimitoptional: false,
            providerTypeOptions: [
                { text: 'ИП / ЮЛ', value: false },
                { text: 'Физическое лицо', value: true }
            ],
            loading: true,
            tabIndex: 0,
            showSpec: false,
            spec: {
                number: 1,
                order: 1,
                name: '',
                count: 1,
                okei: null,
                price: 1
            },
            providerInn: '',
            providerKpp: null,
            foundOrganizationBranches: false,
            selectedProvider: null,
            tmpProvider: null,
            purchase: {
                tru_name: '',
                order_type_id: 2,
                contract_conclusion_date: null,
                contract_execution_date: null,
                deliverables: [],
                limits: {
                    items: []
                },
                execution_documents: [],
                contract_attachment: null,
                failed_fl44_purchase_id: null,
                new_provider: null,
                supplier_id: null,
                status: null,
                is_private_provider: false,
                private_provider_data: {
                    inn: null,
                    name: null,
                    address: null
                },
                fl44_external_purchase_category_id: null,
                deliverable_group_id: null,
                purchase_object: '',
                purchase_limit_year: new Date().getFullYear(),
                comment: '',
                without_vat: false,
                is_advance_report: false,
                customer_contract_number: null,
                supplier_accounting: {
                    bank_type: 'bank',
                    bik: null,
                    bank_name: null,
                    bank_city: null,
                    ks: null,
                    rs: null,
                    ls: null,
                    fo_inn: null,
                    fo_name: null
                },
                reg_number: null
            },
            dictionaries: {
                bankTypes: [],
                orderTypes: [],
                purchaseStatuses: [],
                externalPurchaseCategories: [],
                purchaseCategories: []
            },
            failedPurchaseData: null,
            isLimitsValid: false,
            isSupplierAccountingValid: false,
            limitYears: []
        };
    },
    validations() {
        return {
            purchase: {
                order_type_id: { required },
                fl44_external_purchase_category_id: { required },
                deliverable_group_id: { required },
                purchase_object: { required },
                deliverables: {
                    required,
                    minLength: minLength(1),
                    $each: {
                        ktru_item_id: { required },
                        count: { required, minValue: minValue(0.00001) },
                        price: {
                            required,
                            minValue: minValue(0.01)
                        },
                        vat: {
                            required: requiredIf(() => !this.purchase.without_vat)
                        }
                    }
                },
                contract_conclusion_date: { required },
                contract_execution_date: { required: requiredIf(() => this.purchase.status === 'contract:fulfilled') },
                price: {},
                failed_fl44_purchase_id: {},
                contract_attachment: { required },
                status: { required },
                without_vat: { required },
                execution_documents: {},
                customer_contract_number: { required },
                private_provider_data: {
                    required: requiredIf(() => this.purchase.is_private_provider),
                    inn: { required: requiredIf(() => this.purchase.is_private_provider), minLength: minLength(12), maxLength: maxLength(12) },
                    name: { required: requiredIf(() => this.purchase.is_private_provider), minLength: minLength(3) },
                    address: { required: requiredIf(() => this.purchase.is_private_provider) }
                },
                supplier_accounting: {
                    required: requiredIf(() => this.bankRequired),
                    isSupplierAccountingValid() {
                        return !this.bankRequired || this.isSupplierAccountingValid;
                    }
                }
            }
        };
    },
    async mounted() {
        await this.fillData();
    },
    methods: {
        orderTypeChanged(manual = false) {
            if (manual) {
                this.purchase.fl44_external_purchase_category_id = null;
                this.purchase.deliverable_group_id = null;
                this.purchase.limits.items = [];
                this.iskbklimitoptional = false;
            }

            this.iskbklimitoptional = (this.currentOrderType.is_limits_used && this.iskbklimitoptional) || !this.currentOrderType.is_limits_used;
            const notLimitedExternalPurchaseCategory = this.activeExternalPurchaseCategories.find((item) => !item.price_limited);
            if (this.customerCanCreateHiddenPurchase) {
                this.purchase.fl44_external_purchase_category_id = notLimitedExternalPurchaseCategory.id;
            }

            if (!this.purchase.deliverable_group_id) {
                this.purchase.deliverable_group_id = this.activePurchaseCategories.length === 1 ? this.activePurchaseCategories[0].id : null;
            } else {
                const activeDeliverableGroup = this.activePurchaseCategories.find((item) => (item.id = this.purchase.deliverable_group_id && item.is_active));
                if (!activeDeliverableGroup) {
                    this.purchase.deliverable_group_id = this.activePurchaseCategories.length === 1 ? this.activePurchaseCategories[0].id : null;
                }
            }

            if (this.purchase.failed_fl44_purchase_id) {
                this.purchase.fl44_external_purchase_category_id = this.forFailedFl44PurchaseCategory.id;
                this.purchase.deliverable_group_id = this.failedPurchaseData.purchase_category_id;
            }

            this.$nextTick(() => {
                this.$v.$reset();
            });
        },
        async fillData() {
            range(2019, new Date().getFullYear() + 2).forEach((year) => {
                this.limitYears.push({ id: year, label: year });
            });
            const data = await this.$api.dictionary.getList(['bank_types', 'fl44_external_purchases_categories', 'purchase_categories']);
            this.dictionaries.orderTypes = this.$globalDictionaries.orderTypes.filter((item) => item.is_fl44_external);
            this.dictionaries.purchaseStatuses = this.$globalDictionaries.purchaseStatuses.filter((item) => item.id === 'contract:active');
            this.dictionaries.externalPurchaseCategories = data.fl44_external_purchases_categories;
            this.dictionaries.purchaseCategories = data.purchase_categories;
            this.dictionaries.bankTypes = data.bank_types;
            this.purchase.fl44_external_purchase_category_id = this.activeExternalPurchaseCategories[0].id;
            let isCurrentExternalPurchaseCategoryAvailable = true;

            // NB: Set the purchase types in rearchitected store module.
            if (this.$route.params.mode === 'create' && this.$route.params.id) {
                this.purchase.failed_fl44_purchase_id = parseInt(this.$route.params.id);
                await this.getFailedPurchaseAndFillData();
                // Проверяем наличие предмета закупки в списке предметов закупки
                const foundPurchaseCategory = this.dictionaries.purchaseCategories.find((i) => i.id === this.purchase.deliverable_group_id);
                if (!foundPurchaseCategory) {
                    this.purchase.tru_name = null;
                    this.purchase.deliverable_group_id = null;
                }
                this.purchase.fl44_external_purchase_category_id = this.forFailedFl44PurchaseCategory.id;
            } else if (this.$route.params.mode === 'edit_draft') {
                await this.$api.personal.fl44ExternalPurchases
                    .getDraft(this.$route.params.id)
                    .then(async (response) => {
                        this.tmpProvider = response.draft_data.provider_data?.tmp_provider ?? null;
                        this.providerInn = response.draft_data.provider_data?.provider_inn ?? '';
                        this.providerKpp = response.draft_data.provider_data?.provider_kpp ?? null;
                        this.foundOrganizationBranches = response.draft_data.provider_data?.foundOrganization_branches;
                        this.selectedProvider = response.draft_data.provider_data?.selected_provider ?? null;
                        this.iskbklimitoptional = response.draft_data?.purchase.without_limits;
                        this.purchase = Object.assign(this.purchase, response.draft_data.purchase);
                        if (this.purchase.failed_fl44_purchase_id) {
                            this.failedPurchaseData = await this.$api.personal.fl44ExternalPurchases.getFailedPurchase(this.purchase.failed_fl44_purchase_id);
                        }
                        isCurrentExternalPurchaseCategoryAvailable = this.activeExternalPurchaseCategories.find((item) => item.id === this.purchase.fl44_external_purchase_category_id);
                    })
                    .catch((error) => {
                        if (error && error.response && error.response.status === 404) {
                            this.$router.push({ name: '404' }).catch(() => {});
                        }
                        this.onCancel();
                    });
            }
            this.orderTypeChanged(!isCurrentExternalPurchaseCategoryAvailable);
            this.handleExternalPurchaseCategoryChange(false);
            this.purchase.status = 'contract:active';
            this.loading = false;
        },
        handleExternalPurchaseCategoryChange(reset = true) {
            if (!this.formExternalPurchaseCategory) {
                return;
            }
            this.purchase.is_private_provider = this.formExternalPurchaseCategory.supplier_type === 'individual';
            if (reset) {
                this.purchase.deliverable_group_id = this.activePurchaseCategories.length === 1 ? this.activePurchaseCategories[0].id : null;
            }
            this.$nextTick(() => {
                this.$v.$reset();
            });
        },
        async getFailedPurchaseAndFillData() {
            this.failedPurchaseData = await this.$api.personal.fl44ExternalPurchases.getFailedPurchase(this.purchase.failed_fl44_purchase_id);

            this.purchase.order_type_id = this.failedPurchaseData.order_type_id;
            this.purchase.tru_name = this.failedPurchaseData.tru_name;
            this.purchase.deliverable_group_id = this.failedPurchaseData.purchase_category_id;
            this.purchase.purchase_object = this.failedPurchaseData.purchase_object;
            this.purchase.deliverables = this.failedPurchaseData.items;
            this.purchase.fl44_external_purchase_category_id = this.forFailedFl44PurchaseCategory?.id;
        },
        async findProvider() {
            this.tmpProvider = null;
            this.selectedProvider = null;
            if (this.providerKpp === '') this.providerKpp = null;
            const response = await this.$api.personal.fl44ExternalPurchases.findProvider({ inn: this.providerInn, kpp: this.providerKpp });
            if (response) {
                if (response === 'branches') {
                    this.foundOrganizationBranches = true;
                } else {
                    this.foundOrganizationBranches = false;
                    this.tmpProvider = response;
                }
            }
        },
        selectProvider() {
            this.selectedProvider = this.tmpProvider;
            if (this.tmpProvider.from_dadata) {
                this.purchase.supplier_id = null;
                this.purchase.new_provider = this.tmpProvider;
            } else {
                this.purchase.supplier_id = this.tmpProvider.id;
                this.purchase.new_provider = null;
            }
        },
        async sendData(isDraft = false) {
            this.isDataSending = true;
            try {
                const purchase = { ...this.purchase };
                if (!isDraft) {
                    purchase.limits = this.purchase.limits.items.map((item) => {
                        return {
                            id: item.id,
                            year: item.year,
                            amount_assigned: item.amount_assigned
                        };
                    });
                }
                let storeData = {
                    purchase: {
                        ...purchase,
                        price: this.specSum,
                        without_limits: this.iskbklimitoptional
                    }
                };
                if (isDraft) {
                    const providerData = {
                        tmp_provider: this.tmpProvider,
                        provider_inn: this.providerInn,
                        provider_kpp: this.providerKpp,
                        foundOrganization_branches: this.foundOrganizationBranches,
                        selected_provider: this.selectedProvider
                    };
                    storeData = { ...storeData, provider_data: providerData };
                }

                if (!isDraft && this.iskbklimitoptional) {
                    this.purchase.is_advance_report = false;
                }
                if (!isDraft && this.iskbklimitoptional && this.purchase.is_advance_report) {
                    storeData.purchase.supplier_accounting = null;
                }
                if (this.$route.params.mode === 'edit_draft') {
                    if (await this.$api.personal.fl44ExternalPurchases.updateDraft(storeData, isDraft, this.$route.params.id)) this.onCancel();
                } else {
                    const response = await this.$api.personal.fl44ExternalPurchases.store(storeData, isDraft);
                    if (response) {
                        if (isDraft) {
                            await this.$router.replace({ name: 'ExternalPurchaseCreate', params: { mode: 'edit_draft', id: response.id } });
                            await this.fillData();
                        } else {
                            this.onCancel();
                        }
                    }
                }
            } catch (error) {
                if (error && error.response && error.response.status === 404) {
                    this.$router.push({ name: '404' }).catch(() => {});
                }
            } finally {
                this.isDataSending = false;
            }
        },
        onCancel() {
            this.$router.push({ name: 'CabinetFl44ContractsList' }).catch(() => {});
        },
        limitsValidate(value) {
            this.isLimitsValid = !value;
        },
        supplierAccountingValidate(value) {
            this.isSupplierAccountingValid = !value;
        }
    },
    computed: {
        isForbiddenSupplier() {
            return this.tmpProvider.id && !this.tmpProvider.from_dadata && this.failedPurchaseData && !!this.failedPurchaseData.forbidden_suppliers.find((item) => item?.inn === this.tmpProvider.inn && (!this.providerKpp || item?.kpp === this.tmpProvider.kpp));
        },
        isBasedOnFailedPurchase() {
            return !!this.purchase.failed_fl44_purchase_id;
        },
        Config() {
            return Config;
        },
        purchaseId() {
            return this.$route.params.mode === 'edit_draft' ? this.$route.params.id : null;
        },
        bankRequired() {
            return this.features.kbk_limits && !(this.iskbklimitoptional || this.purchase.is_advance_report);
        },
        features() {
            return Config.get('theme.features');
        },
        ...mapGetters(['getOrganization', 'customerCanCreateHiddenPurchase']),
        isValid() {
            const kbk_limits = this.features.kbk_limits ? this.isLimitsValid || this.iskbklimitoptional : true;
            return (
                !this.specErrors && !this.limitError && kbk_limits && ((this.selectedProvider && !this.selectedProvider.from_dadata) || (this.selectedProvider && this.selectedProvider.from_dadata && this.purchase.new_provider.email) || this.purchase.is_private_provider) && !this.$v.purchase.$invalid
            );
        },
        specErrors() {
            return !!this.specErrorMessage;
        },
        limitError() {
            return !!this.limitErrorMessage;
        },
        limitErrorMessage() {
            if (!this.isLimitsValid && !this.$data.iskbklimitoptional) return 'Проверьте правильность заполнения таблицы лимитов';
            return '';
        },
        specErrorMessage() {
            if (this.purchase.deliverables.length === 0) return 'Заполните спецификацию';
            if (!this.purchase.deliverables.every((e) => e.count > 0)) return 'У одной или нескольких позиций в спецификации не заполнено поле "Количество"';
            if (!this.purchase.deliverables.every((e) => e.price > 0)) return 'У одной или нескольких позиций в спецификации не заполнено поле "Цена за единицу"';
            if (!this.purchase.deliverables.every((e) => this.purchase.without_vat || e.vat !== null)) return 'У одной или более позиций в таблице спецификации не заполнено поле "НДС"';
            if (this.purchase.failed_fl44_purchase_id && this.specSum > this.failedPurchaseData?.start_price) return 'Превышена НЦК несостоявшейся закупки (' + this.$formatPrice(this.failedPurchaseData?.start_price) + ' руб.)';

            if (!this.purchase.fl44_external_purchase_category_id) {
                if (this.specSum > 10000) return 'Превышена максимальная допустимая сумма спецификации (' + this.$formatPrice(10000) + ' руб.)';
            } else {
                if (this.specSum > this.priceLimit) return 'Превышена максимальная допустимая сумма спецификации (' + this.$formatPrice(this.priceLimit) + ' руб.)';
            }
            return '';
        },
        specSum() {
            return roundToTwoDecimals(this.purchase.deliverables.reduce((acc, cv) => acc + roundToTwoDecimals(cv.count * cv.price), 0));
        },
        newProviderEmailState() {
            if (!this.selectedProvider || !this.selectedProvider.from_dadata) {
                return true;
            }
            const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(this.purchase.new_provider.email);
        },
        currentOrderType() {
            return this.dictionaries.orderTypes.find((item) => item.id === this.purchase.order_type_id);
        },
        priceLimit() {
            const orderTypePriceLimit = this.currentOrderType.max_amount ?? 9999999999999.0;
            const categoryPriceLimit = this.formExternalPurchaseCategory?.price_limit ?? orderTypePriceLimit;
            if (this.isBasedOnFailedPurchase && this.failedPurchaseData?.start_price) {
                return roundToTwoDecimals(Math.min(orderTypePriceLimit, categoryPriceLimit, this.failedPurchaseData?.start_price));
            }
            return roundToTwoDecimals(Math.min(orderTypePriceLimit, categoryPriceLimit));
        },
        formExternalPurchaseCategory() {
            return this.dictionaries.externalPurchaseCategories.find((item) => item.id === this.purchase.fl44_external_purchase_category_id);
        },
        currentExternalPurchaseCategorySupplierLimited() {
            return this.formExternalPurchaseCategory?.supplier_type !== 'any';
        },
        activePurchaseCategories() {
            if (!this.purchase.fl44_external_purchase_category_id) {
                return [];
            }
            if (this.formExternalPurchaseCategory?.deliverable_groups_limited) {
                return this.formExternalPurchaseCategory.deliverable_groups_limit_type_include
                    ? this.dictionaries.purchaseCategories.filter((item) => this.formExternalPurchaseCategory.deliverable_groups.includes(item.id)).filter((item) => item.is_active)
                    : this.dictionaries.purchaseCategories.filter((item) => !this.formExternalPurchaseCategory.deliverable_groups.includes(item.id)).filter((item) => item.is_active);
            }
            return this.dictionaries.purchaseCategories.filter((item) => item.is_active);
        },
        activeExternalPurchaseCategories() {
            return this.dictionaries.externalPurchaseCategories.filter((item) => item.is_active && this.currentOrderType.fl44_external_purchase_categories.includes(item.id));
        },
        forFailedFl44PurchaseCategory() {
            return this.dictionaries.externalPurchaseCategories?.find((item) => item.for_failed_fl44_purchase);
        },
        statusTitle() {
            return this.$globalDictionaries.purchaseStatuses.find((item) => item.id === this.purchase.status).title;
        }
    }
};
</script>

<style scoped>
.red-star {
    color: red;
}

.main_layer {
    background-image: url('/images/purchases_head.svg');
    background-repeat: no-repeat;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;
    min-height: 150px;
}

input::-webkit-input-placeholder {
    color: #959ba4 !important;
    opacity: 0.5 !important;
}

input:-moz-placeholder {
    color: #959ba4 !important;
    opacity: 0.5 !important;
}

input::-moz-placeholder {
    color: #959ba4 !important;
    opacity: 0.5 !important;
}

input:-ms-input-placeholder {
    color: #959ba4 !important;
    opacity: 0.5 !important;
}

input::-ms-input-placeholder {
    color: #959ba4 !important;
    opacity: 0.5 !important;
}

input::placeholder {
    color: #959ba4 !important;
    opacity: 0.5 !important;
}

input {
    border-color: rgba(149, 155, 164, 0.2);
}

.table thead th {
    background: #e4e6e8;
    font-size: 14px;
    font-weight: 600;
    padding: 12px;
    color: var(--grey-color);
}

.table tbody td {
    font-size: 14px;
    /*font-weight: 600;*/
    padding: 12px;
    vertical-align: middle;
    border-bottom: 1px solid #dee2e6;
    color: var(--grey-color);
}

.end_list li {
    margin: 15px 0;
    font-size: 14px;
    color: var(--grey-color);
    position: relative;
}

.end_list li::before {
    content: '';
    position: absolute;
    top: 8px;
    left: -15px;
    width: 5px;
    height: 5px;
    -webkit-border-radius: 50%;
    -moz-border-radius: 50%;
    border-radius: 50%;
    background: var(--green-color);
}

@media screen and (max-width: 769px) {
    .if-tablet {
        font-size: 40px !important;
    }
}
</style>

<style lang="less">
@subtext-color: #777;
@preloader-bg-color: rgba(255, 255, 255, 0.75);
@suggestions-bg-color: #fff;
@subtext-label-color: #f5f5f5;

.box-sizing(@sizing: border-box) {
    box-sizing: @sizing;
}

.rounded(@radius) {
    -webkit-border-radius: @radius;
    -moz-border-radius: @radius;
    border-radius: @radius;
}

.cross-button-mixin() {
    @cross-padding: 20;
    @cross-ray-width: 10;
    @cross-ray-length: 50 - @cross-padding - @cross-ray-width;
    @svg: "<svg width='100' height='100' xmlns='http://www.w3.org/2000/svg'><g><path d='m@{cross-padding},@{cross-padding}m@{cross-ray-width},0l@{cross-ray-length},@{cross-ray-length}l@{cross-ray-length},-@{cross-ray-length}l@{cross-ray-width},@{cross-ray-width}l-@{cross-ray-length},@{cross-ray-length}l@{cross-ray-length},@{cross-ray-length}l-@{cross-ray-width},@{cross-ray-width}l-@{cross-ray-length},-@{cross-ray-length}l-@{cross-ray-length},@{cross-ray-length}l-@{cross-ray-width},-@{cross-ray-width}l@{cross-ray-length},-@{cross-ray-length}l-@{cross-ray-length},-@{cross-ray-length}l@{cross-ray-width},-@{cross-ray-width}' fill='#999'/></g></svg>";
    @svg64: `new Buffer(@{svg}) .toString('base64') `;
    background: transparent url('data:image/svg+xml;base64,@{svg64}') 50% 50% no-repeat;
    background-size: contain;

    cursor: pointer;
    opacity: 0.8;

    &:hover {
        opacity: 1;
    }
}

.suggestions-nowrap {
    white-space: nowrap;
}

/**
   * Основной INPUT
   */
.suggestions-input {
    // IE9 can't determine border-style until it is specified in stylesheets
    //  border: 1px solid grey;
    .box-sizing();
    width: 100%;

    &::-ms-clear {
        display: none;
    }
}

.suggestions-wrapper {
    position: relative;
    margin: 0;
    padding: 0;
    vertical-align: top;

    //Prevent font scaling in landscape while allowing user zoom
    -webkit-text-size-adjust: 100%;
}

/**
   * Блок в правой части основного INPUT'а
   * В нем показывается иконка ЗАГРУЗКА
   */
.suggestions-addon {
    display: none;
    opacity: 0;
    position: absolute;

    &[data-addon-type='spinner'] {
        background: @preloader-bg-color
            url('data:image/gif;base64,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')
            50% 50% no-repeat;
        .rounded(50%);
    }

    &[data-addon-type='clear'] {
        .cross-button-mixin();
    }
}

/**
   * Выпадающий блок с найденными подсказками
   */
.suggestions-suggestions {
    background: @suggestions-bg-color;
    border: 1px solid #999;
    .box-sizing;
    cursor: default;
    z-index: 9999;

    //Prevent font scaling in landscape while allowing user zoom
    -webkit-text-size-adjust: 100%;

    strong {
        font-weight: normal;
        color: #3399ff;
    }

    &.suggestions-mobile {
        border-style: none;

        .suggestions-suggestion {
            border-bottom: 1px solid #ddd;
        }
    }
}

/**
   * Контейнер для одной подсказки
   */
.suggestions-suggestion {
    padding: 4px 4px;
    overflow: hidden;

    &:hover {
        background: darken(@suggestions-bg-color, 3%);
    }
}

/**
   * Выбранная (активная) подсказка
   */
.suggestions-selected {
    background: darken(@suggestions-bg-color, 6%);

    &:hover {
        background: darken(@suggestions-bg-color, 6%);
    }
}

/**
   * Информационный блок в верхней части выпадашки с подсказками
   */
.suggestions-hint {
    padding: 4px 4px;
    white-space: nowrap;
    overflow: hidden;
    color: @subtext-color;
    font-size: 85%;
    line-height: 20px;
}

/**
   * Ограничения поиска, показываются в левой части основного INPUT'а
   */
.suggestions-constraints {
    list-style: none !important;
    margin: 0 !important;
    padding: 0 !important;
    position: absolute !important;
    white-space: nowrap !important;

    &:empty {
        display: none !important;
    }

    li {
        background: #f8f8f8;
        border: 1px solid #ccc;
        .rounded(3px);
        cursor: default;
        display: inline-block;
        margin: 0 4px 0 0;
        padding: 0 0.5em;

        .suggestions-remove {
            @icon-size: 1em;
            height: @icon-size;
            width: @icon-size;
            display: inline-block;

            margin: 0 0 0 0.25em;
            .cross-button-mixin();
        }

        span {
            vertical-align: middle;
        }
    }
}

/**
   * Дополнительный текст в подсказке, который идет второй строкой
   */
.suggestions-subtext {
    color: @subtext-color;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

/**
   * Размещает дополнительный текст в одну строку с основным текстом подсказки
   */
.suggestions-subtext_inline {
    display: inline-block;
    min-width: 6em;
    vertical-align: bottom;
    margin: 0 0.5em 0 0;
}

/**
   * Разделитель нескольких дополнительных текстов
   */
.suggestions-subtext-delimiter {
    display: inline-block;
    width: 2px;
}

/**
   * Выделяет подсказку
   */
.suggestions-subtext_label {
    margin: 0 0 0 0.25em;
    .rounded(3px);
    padding: 0 3px;

    background: @subtext-label-color;
    font-size: 85%;
}

.suggestions-value {
    &[data-suggestion-status='LIQUIDATED'] {
        position: relative;

        &:after {
            position: absolute;
            left: 0;
            right: 0;
            top: 50%;

            border-top: 1px solid rgba(0, 0, 0, 0.4);

            content: '';
        }
    }
}

/**
   * Промо-блок
   */
.suggestions-promo {
    font-size: 85%;
    display: none;
    color: @subtext-color;
    padding: 4px;
    text-align: center;

    a {
        color: @subtext-color;
        display: block;
        filter: grayscale(100%);
        line-height: 20px;
        text-decoration: none;
    }

    a:hover {
        filter: grayscale(0);
    }

    svg {
        height: 20px;
        vertical-align: bottom;
    }
}

.suggestions-promo-desktop {
    position: absolute;
    top: 0;
    right: 0;
    text-align: left;
}
</style>
